function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M20.518 6.734H3.482A.48.48 0 013 6.255V4.98a.48.48 0 01.482-.479h17.036A.48.48 0 0121 4.98v1.276a.48.48 0 01-.482.479zm0 6.383H3.482A.48.48 0 013 12.638v-1.276a.48.48 0 01.482-.479h17.036a.48.48 0 01.482.479v1.276a.48.48 0 01-.482.479zm0 6.383H3.482A.48.48 0 013 19.021v-1.276a.48.48 0 01.482-.479h17.036a.48.48 0 01.482.479v1.276a.48.48 0 01-.482.479z"
});

function SvgHamburgerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgHamburgerinline;